import { createSlice } from "@reduxjs/toolkit";
import { bettingApi } from "../../sharedfiles/EndpointConfig";
import {
  cleanObject,
  messageEnhancer,
  toaster,
} from "../../sharedfiles/helper";
import { apiCaller } from "../../api/apiCaller";

export const stakeConfigSlice = createSlice({
  name: "stakeConfig",
  initialState: {
    stakeConfigs: [],
    countries: "",
    sports: "",
    currencyCode: "",
    configuredCurrencyCode: "",
    leagueStates: {},
  },
  reducers: {
    setStakeConfig: (state, action) => {
      state.stakeConfigs = action.payload;
    },
    setCountries: (state, action) => {
      state.countries = action.payload;
    },
    setSports: (state, action) => {
      state.sports = action.payload;
    },
    setCurrencyCode: (state, action) => {
      state.currencyCode = action.payload;
    },
    setConfiguredCurrencyCode: (state, action) => {
      state.configuredCurrencyCode = action.payload;
    },
    setLeagueStates: (state, action) => {
      const { leagueId, field, value } = action.payload;
      state.leagueStates = {
        ...state.leagueStates,
        [leagueId]: {
          ...state.leagueStates[leagueId],
          [field]: value,
        },
      };
    },
    resetLeagueStates: (state) => {
      state.leagueStates = {};
    },
  },
});

export const { setStakeConfig, setCountries, setSports, setCurrencyCode, setConfiguredCurrencyCode, setLeagueStates, resetLeagueStates } =
  stakeConfigSlice.actions;

export const saveCofig = (params) => (dispatch) => {
  const url = bettingApi().saveConfig;
  // const hydratedFields = cleanObject(params);
  apiCaller(url, "POST", params)
    .then((response) => {
      if (response !== null && response) {
        if (response.status == 200) {
          toaster.success(messageEnhancer(response.msg));
        }
      }
    })
    .catch((err) => {
      console.error(err);
      toaster.error(messageEnhancer(err.response));
    });
};
export const getConfig = (currencyCode) => async (dispatch) => {
  // currencyCode is sent only when selected - omitted entirely otherwise
  const url = currencyCode
    ? `${bettingApi().getConfig}?currencyCode=${encodeURIComponent(currencyCode)}`
    : bettingApi().getConfig;
  apiCaller(url, "GET")
    .then((response) => {
      if (response !== null && response) {
        if (response.status == 200) {
          let finaldata = response.data.reverse()
          dispatch(setStakeConfig(finaldata));
        }
      }
    })
    .catch((err) => {
      console.error(err);
    });
};

export const updateConfig = (params) => async (dispatch) => {
  const url = bettingApi().updateConfig;
  const hydratedFields = cleanObject(params);
  apiCaller(url, "PUT", hydratedFields)
    .then((response) => {
      if (response !== null && response) {
        if (response.status == 200) {
          toaster.success(messageEnhancer(response.msg));
        }
      }
      
    })
    .catch((err) => {
      console.error(err);
      toaster.error(messageEnhancer(err.response));
    });
};

export default stakeConfigSlice.reducer;
